import { lazy } from "react";

export const LazyFirmSettingsPage = lazy(async () => ({
    default: (await import("./FirmSettingsPage")).FirmSettingsPage
}));
